import { SvgIcon, SvgIconProps } from "@mui/material";

type Props = SvgIconProps;

export function Search(props: Props) {
  return (
    <SvgIcon {...props}>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M14.015 14.015L20 20M9.86667 15.7333C13.1067 15.7333 15.7333 13.1067 15.7333 9.86667C15.7333 6.6266 13.1067 4 9.86667 4C6.6266 4 4 6.6266 4 9.86667C4 13.1067 6.6266 15.7333 9.86667 15.7333Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    </SvgIcon>
  );
}
